import { Typography, Box } from '@mui/material';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { withTranslation } from 'react-i18next';

const GooglePlaces = (props) => {
    const { name, label, bodyStyle, className, labelStyle, getUrl } = props;

    const { control, setValue, trigger, watch } = useFormContext();
    const fieldValue = watch(name);
    const [mapValue, setMapValue] = useState(null);

    // Generate Google Maps URL from selected place
    const generateUrl = useCallback(() => {
        const description = mapValue?.value?.description;
        if (!description) return;

        const encoded = description.replace(/\s+/g, '+').replace(/,/g, '');
        const url = `https://www.google.com/maps/search/?api=1&query=${encoded}`;

        getUrl?.(url);
        setValue(name, url);
    }, [mapValue, setValue, getUrl, name]);

    useEffect(() => {
        generateUrl();
    }, [mapValue, generateUrl]);

    useEffect(() => {
        if (fieldValue) trigger(name);
    }, [fieldValue, trigger, name]);

    return (
        <Controller
            control={control}
            name={name}
            render={({ fieldState: { error } }) => (
                <Box sx={{ ...bodyStyle }} className={className}>
                    <Typography sx={{ ...labelStyle }} className="text-secondary inline-block mb-3">
                        {label || 'Enter the location of your head office'}
                    </Typography>

                    <GooglePlacesAutocomplete
                        apiKey="AIzaSyCYmUUvNW1HOjzAI1oTWH658wOflEgLBEU"
                        selectProps={{
                            value: mapValue,
                            onChange: setMapValue,
                            placeholder: mapValue?.value?.description || 'Select an address',
                            styles: {
                                placeholder: () => ({
                                    color: mapValue ? 'black' : 'grey',
                                }),
                                input: () => ({
                                    padding: '13px',
                                    width: '100%',
                                }),
                            },
                        }}
                    />

                    {/* Link Preview */}
                    {fieldValue && (
                        <Box
                            component="a"
                            href={fieldValue}
                            target="_blank"
                            sx={{ textDecoration: 'none', display: 'block', marginTop: '12px' }}
                        >
                            {fieldValue.includes('maps/search') ? 'Confirm URL' : 'Error generating link'}
                        </Box>
                    )}

                    {error && (
                        <Typography color="error" variant="caption">
                            {error.message}
                        </Typography>
                    )}
                </Box>
            )}
        />
    );
};

export default withTranslation()(GooglePlaces);
